<template>
  <v-card>
    <div class="d-flex justify-space-between pa-4 pb-0">
      <v-card-title class="small-title">Roles & rates</v-card-title>
      <div class="d-flex">
        <Button
          id="add-estimate-button"
          color="primary"
          @clickAction="addEstimateRoleDialog = true"
        >
          {{ "Add" }}
        </Button>
      </div>
    </div>
    <v-data-table
      class="assignments-table pb-4"
      item-key="id"
      disable-pagination
      hide-default-footer
      :headers="headers"
      :items="items"
      :sort-by="['estimationRole.name']"
    >
      <template #item="{ item, headers, isSelected, select, index }">
        <ProjectEstimateRoleRow
          :key="index"
          :headers="headers"
          :selected="isSelected"
          :select="select"
          :estimation-role="item"
          :allowed="allowed"
          @onDelete="askRoleDeleteConfirmation"
          @onSave="saveRole"
        />
      </template>
    </v-data-table>

    <AddEstimateRoleDialog
      :is-opened="addEstimateRoleDialog"
      @close="addEstimateRoleDialog = false"
      @save="refreshProjectRoles"
    />

    <DeletionConfirmationDialog
      :dialog="deleteRoleDialog"
      title="Confirmation"
      text="Are you sure you want to delete this employee from the project?"
      confirmation-button-text="Delete"
      @confirmationAction="roleDeleteConfirmation"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import AddEstimateRoleDialog from '@/components/projects/AddEstimateRoleDialog.vue';
import ProjectEstimateRoleRow from '@/components/projects/ProjectEstimateRoleRow.vue';
import {
  Button,
  Dialog as DeletionConfirmationDialog,
} from '@/components/shared';
import { DateHelper } from '@/helpers/date.helper';

export default {
  components: {
    ProjectEstimateRoleRow,
    AddEstimateRoleDialog,
    Button,
    DeletionConfirmationDialog,
  },
  filters: {
    dateToDisplay: DateHelper.formatDateAccordingSettings,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Employees',
    },
    items: {
      type: Array,
      required: true,
    },
    allowed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Role',
          value: 'estimationRole.name',
          sortable: false,
        },
        {
          text: 'Rate',
          value: 'estimationRole.rate',
          sortable: false,
        },
      ],
      addEstimateRoleDialog: false,
      deleteRoleDialog: false,
      itemToDelete: '',
    };
  },
  computed: {
    ...mapGetters('user/settings', ['denseTables', 'dateFormatSettings']),
    ...mapGetters('projects/main', ['project', 'search']),
    ...mapGetters('auth/account', ['isUserAdmin']),
  },
  methods: {
    ...mapActions('projects/main', [
      'removeEstimateRoleFromProject',
      'updateProjectEstimateRole',
      'getProjectEstimationRoles',
      'getProjectAssignments',
    ]),
    ...mapMutations('projects/main', ['setProjectAssignments']),

    askRoleDeleteConfirmation(item) {
      this.itemToDelete = item;
      this.deleteRoleDialog = true;
    },
    async roleDeleteConfirmation(confirmed) {
      if (confirmed) {
        await this.removeEstimateRoleFromProject({
          roleId: this.itemToDelete.id,
        });
        await this.refreshProjectRoles();
      }

      this.deleteRoleDialog = false;
    },
    async saveRole(role) {
      try {
        await this.updateProjectEstimateRole({
          roleId: role.id,
          role,
        });
      } catch (error) {
        this.flashError('An error occured while updating assignment.');
      } finally {
        await this.refreshProjectRoles();
        await this.getProjectAssignments({ projectId: this.project.id });
      }
    },
    async refreshProjectRoles() {
      await this.getProjectEstimationRoles({ projectId: this.project.id });
    },
  },
};
</script>

<style lang="less">
.assignments-table {
  overflow: auto;

  .ripple-scale.v-input--selection-controls:not(.v-input--switch)
    .v-input--selection-controls__ripple {
    transform: scale(0.6);
  }

  table .shadow {
    color: darkgray;
  }
}

.action-column {
  .row {
    margin: 0;

    .v-btn {
      color: #555;
      margin: 1px;
      height: inherit;
      width: inherit;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        transition: all 0.5s ease;
      }
    }
  }
}
</style>
